<section class="guts-m-h-1-half">
  <div class="l_flex m-no-guts">
    <div class="left-panel l_flex l_flex-column guts-m-r-1-half m-guts-m-h-0">
      <div>
        <dgx-skeleton type="mediumTitle"></dgx-skeleton>
        <div class="guts-p-t-2 guts-p-b-3">
          <dgx-skeleton type="skillsTable"></dgx-skeleton>
        </div>
      </div>

      <div class="guts-p-b-3">
        <dgx-skeleton type="mediumTitle"></dgx-skeleton>
        <div class="guts-p-t-2">
          <dgx-skeleton type="experiencesTable"></dgx-skeleton>
        </div>
      </div>

      <div>
        <dgx-skeleton type="mediumTitle"></dgx-skeleton>
        <div class="l_flex guts-p-t-2 guts-p-b-3">
          <dgx-skeleton
            type="userOutcome"
            class="grid__col-md-4 guts-p-l-0 m-guts-p-full-0"
          ></dgx-skeleton>
          <dgx-skeleton
            type="userOutcome"
            class="grid__col-md-4 no-mobile"
          ></dgx-skeleton>
          <dgx-skeleton
            type="userOutcome"
            class="grid__col-md-4 no-mobile guts-p-r-0"
          ></dgx-skeleton>
        </div>
      </div>
      <div>
        <dgx-skeleton type="mediumTitle"></dgx-skeleton>
        <div class="l_flex guts-p-t-2 guts-p-b-3">
          <dgx-skeleton
            type="userOutcome"
            class="grid__col-md-4 guts-p-l-0 m-guts-p-full-0"
          ></dgx-skeleton>
          <dgx-skeleton
            type="userOutcome"
            class="grid__col-md-4 no-mobile"
          ></dgx-skeleton>
          <dgx-skeleton
            type="userOutcome"
            class="grid__col-md-4 no-mobile guts-p-r-0"
          ></dgx-skeleton>
        </div>
      </div>
    </div>
    <div
      *ngIf="ownerIsViewing"
      class="l_flex l_flex-justify-right guts-m-h-1-half no-mobile"
    >
      <div class="full-width">
        <dgx-skeleton type="buildYourProfile"></dgx-skeleton>
      </div>
    </div>
  </div>
</section>
